export default __webpack_public_path__ + "static/media/understandingTech_icon.d1172f0b.webp";